<template>
  <div>
    <toolbar :title="`${company.companyName} : Load Transactions`" :extended="isMobile">
      <v-layout :slot="isMobile ? 'extension' : null">
        <v-toolbar-items >
          <template v-for="(item, idx) in toolbarNavButtonsData">
            <v-btn flat small right
                   :key="`txn_toolbar_nav_${idx}`"
                   class="toolbar-btn px-1"
                   :to="{name: item.routeName}">
              <v-layout column class="align-center">
                <v-icon>{{item.iconName}}</v-icon>
                <v-progress-linear color="white"
                                   class="mt-2 mb-0"
                                   v-if="loadingTransactions"
                                   :indeterminate="true">
                </v-progress-linear>
                <template v-else>
                  {{ item.count }}
                </template>
              </v-layout>
            </v-btn>
          </template>


        </v-toolbar-items>
      </v-layout>
    </toolbar>

    <router-view :company="company" />
  </div>
</template>

<script>
import _ from 'lodash';
import Toolbar from '@/components/Toolbar';

import loadTransactionsMixin from '@/mixins/loadTransactionsMixin';
import companySectionMixin from '@/mixins/companySectionMixin';
import companyPluginsMixin from '@/mixins/companyPluginsMixin';
import filterLoadsMixin from '@/mixins/filterLoads';

export default {
  name: 'TransactionsPage',
  mixins: [
    loadTransactionsMixin,
    companySectionMixin,
    filterLoadsMixin,
    companyPluginsMixin,
  ],
  components: {
    Toolbar,
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    toolbarNavButtonsData() {
      const strategy = this.companySettlementStrategy(this.company);
      return _.get(strategy, 'transactionsToolbar.navButtons', []);
    },
  },
  methods: {
    loadData() {
      this.onRefresh();
    },
    onRefresh() {
      this.loadCompanyTransactions(this.company.id);
    },
  },
  created() {
    this.loadCompanyTransactions(this.company.id);
  },
};
</script>

<style>
  .toolbar-btn {
    min-width: 48px;
  }

  .toolbar-btn.v-btn--active {
    border-bottom: 2px solid white;
  }

  .toolbar-btn:before,
  .toolbar-btn:focus:before,
  .toolbar-btn:hover:before {
    background-color: transparent !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Transactions/TransactionsPage.vue